module.exports = __webpack_public_path__ + "img/slack-channel.188b0b62.svg";